export const featuredCases = [
  {
    id: "case-school-zone-buk",
    title: "2025년 어린이보호구역 도색정비공사",
    period: "2025.12.02-2025.12.29",
    method: "노란색 도로용 페인트 도색 (횡단보도 및 어린이보호구역 표기)",
    product: "도로용 황색 페인트",
    location: "부산광역시 북구",
    category: "도로도색",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/244b97a8-1084-4b60-a25d-f3d6a798c876_compressed_image1.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/800dad52-941a-41f4-97e9-b91af4c07dd4_compressed_image3.webp",
  },
  {
    id: "case-cctv-saha",
    title: "CCTV통합관제센터 구조환경개선공사",
    period: "2025.09.17-2025.12.15",
    method: "전체 리모델링 공사 (천장·바닥·벽체·전기·설비 전면 개선)",
    product: "리모델링 자재 일식",
    location: "부산광역시 사하구",
    category: "내부리모델링",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/c5d73895-cc88-446b-a7e0-0bd4362133fb_compressed_-CCTV-.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/b7298b0b-6c72-462f-9d4d-0ea88e527203_compressed_-CCTV--.webp",
  },
  {
    id: "case-sinil",
    title: "신일화학 음성공장 에폭시슬라이스 바닥공사",
    period: "2023.07.10-2023.07.21",
    method: "에폭시 슬라이스 공법 (라이닝 0.5MM + 코팅 0.1MM)",
    product: "삼화페인트 에폭시라이닝",
    location: "충북 음성군",
    category: "에폭시슬라이스",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/ddd2ac1c-d603-4ab8-b132-9abf02130d1d_compressed_1.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/21b34192-f0b8-4024-809b-3f8edfc3d53d_compressed_1.webp",
  },
  {
    id: "case-youngchemical",
    title: "영케미칼 양산공장 에폭시라이닝 바닥공사",
    period: "2023.12.10-2023.12.20",
    method: "데코타일 제거 → 스키로더 연삭작업 → DNC에폭시 라이닝 3MM 도포",
    product: "DNC에폭시라이닝",
    location: "경남 양산시",
    category: "에폭시라이닝",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/4f41e175-8806-42a5-8e54-9e3b04758727_compressed_unnamed.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/d6cb5187-c3c6-41ea-8513-02a1c85d038c_compressed_-.webp",
  },
  {
    id: "case-deokcheon",
    title: "덕천아트빌라일원 옹벽경관개선사업",
    period: "2022.05.12-2022.08.09",
    method: "고압세척 후 옹벽 이형타일 시공 → 중성화방지도장 마감",
    product: "이형타일 · 중성화방지도료",
    location: "부산광역시 북구",
    category: "옹벽경관개선",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/e9de96c5-f44a-4fb4-9895-18209d22c507_compressed_--.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/56bf7494-943c-4f92-85fd-d84082eb7286_compressed_-.webp",
  },
  {
    id: "case-jeilhwasung",
    title: "제일화성 온산공장 외벽판넬 도장공사",
    period: "2025.12.09-2025.12.17",
    method: "글라인더 부식 제거 → 보강작업 → 멀티에폭시 프라이머 도장 → 중성화방지도료 도장",
    product: "멀티에폭시 프라이머 · 중성화방지도료",
    location: "울산광역시 울주군",
    category: "외벽판넬도장",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/ef4df911-8fbc-4382-b302-b36304ee1f8f_compressed_-.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/dbdeaa97-8b38-4b7a-b6d3-4d8b5a9748c3_compressed_-.webp",
  },
  {
    id: "case-jeonggwan",
    title: "정관보건지소 옥상·옥탑 방수공사",
    period: "2026.03.10-2026.04.03",
    method: "기존 우레탄 전면 제거(스키로더) 후 우레탄 프라이머 · 우레탄 방수제 3MM · 우레탄 상도",
    product: "DNC우레탄 KS인증 제품",
    location: "부산광역시 기장군",
    category: "옥상방수",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/19976f51-92a8-4b50-93ea-a32d20790bfb_compressed_-.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/180b6a81-f7cb-4508-b153-d58210a7615e_compressed_-.webp",
  },
  {
    id: "case-bujeon",
    title: "부전인삼시장 노후화장실 개선공사",
    period: "2026.02.09-2026.04.24",
    method: "슬라브층 전면 철거 후 방수 · 화장실 리모델링",
    product: "방수재 · 위생도기 · 타일",
    location: "부산광역시 부산진구",
    category: "화장실 리모델링",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/966b4be7-5d20-4ab4-8c93-397b1e02c6e0_compressed_--.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/5b40e1f3-37a6-43a0-a37a-fbf830d2be6b_compressed_--.webp",
  },
  {
    id: "case-00",
    title: "글로벌10003 도장공사",
    period: "2025.05.22-2025.06.14",
    method: "선박용 에폭시 프라이머 · 에폭시 코팅제 중도 · 에폭시 코팅제 상도",
    product: "PPG(데크) / 헴펠코리아(외판)",
    location: "부산광역시 감천동",
    category: "선박도장",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/d096c900-d86c-4b12-a0f1-035f20cf678b_compressed_20250522_150454.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/0fab9cee-c57a-4274-b515-d33be71510d1_compressed_20250529_103003.webp",
  },
  {
    id: "case-donggu",
    title: "동구노인복지관 분관 외벽도장",
    period: "2026.04.09-2026.05.11",
    method: "외부드라이비트 도장공사",
    product: "외부용 고급 도료",
    location: "부산광역시 동구",
    category: "외벽도장",
    before:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/205e5ee5-f00a-4729-911d-fb3e69b9ef60_compressed_-.webp",
    after:
      "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/abe25e95-13fb-4c94-a8c1-036945b33b34_compressed_-.webp",
  },
];